import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, RequireAuth } from "lib/auth";
import Layout from "components/Layout";
import HomePage from "pages/HomePage";
import AboutPage from "pages/AboutPage";
import AcademicsPage from "pages/AcademicsPage";
import AdmissionsPage from "pages/AdmissionsPage";
import GalleryPage from "pages/GalleryPage";
import ResultsPage from "pages/ResultsPage";
import ActivityPage from "pages/ActivityPage";
import DepartmentPage from "pages/DepartmentPage";
import ContactPage from "pages/ContactPage";
import NoticesPage from "pages/NoticesPage";
import InstitutionPage from "pages/InstitutionPage";

import { LangProvider } from "components/admissions/portalUi";
import PortalLanding from "pages/admissions/PortalLanding";
import PortalStart from "pages/admissions/PortalStart";
import PortalContinue from "pages/admissions/PortalContinue";
import PortalSection from "pages/admissions/PortalSection";
import PortalReview from "pages/admissions/PortalReview";
import AdminLayout from "components/admin/AdminLayout";
import LoginPage from "pages/admin/LoginPage";
import DashboardPage from "pages/admin/DashboardPage";
import AdminSlidesPage from "pages/admin/SlidesPage";
import AdminMarqueePage from "pages/admin/MarqueePage";
import AdminSectionsPage from "pages/admin/SectionsPage";
import AdminInstitutionsPage from "pages/admin/InstitutionsPage";
import AdminDepartmentsPage from "pages/admin/DepartmentsPage";
import AdminNoticesPage from "pages/admin/NoticesPage";
import AdminResultsPage from "pages/admin/ResultsPage";
import AdminGalleryPage from "pages/admin/GalleryPage";
import AdminManagementPage from "pages/admin/ManagementPage";
import AdminTeachersPage from "pages/admin/TeachersPage";
import AdminAcademicsPage from "pages/admin/AcademicsPage";
import AdminAboutContentPage from "pages/admin/AboutContentPage";
import AdminAdmissionsPage from "pages/admin/AdmissionsPage";
import AdminAdmissionsContentPage from "pages/admin/AdmissionsContentPage";
import AdminAdmissionRoundsPage from "pages/admin/AdmissionRoundsPage";
import AdminAdmissionResourcesPage from "pages/admin/AdmissionResourcesPage";
import AdminActivityContentPage from "pages/admin/ActivityContentPage";
import AdminMessagesPage from "pages/admin/MessagesPage";
import SettingsPage from "pages/admin/SettingsPage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public reader site */}
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/academics" element={<AcademicsPage />} />
            <Route path="/academics/:inst" element={<AcademicsPage />} />
            {/* No general admissions page — admissions are per institution. */}
            <Route path="/admissions" element={<Navigate to="/admissions/kcns" replace />} />
            <Route path="/admissions/:inst" element={<AdmissionsPage />} />
            {/* Single application workspace for every institution. */}
            <Route path="/admissions-portal" element={<LangProvider><PortalLanding /></LangProvider>} />
            <Route path="/admissions-portal/start" element={<LangProvider><PortalStart /></LangProvider>} />
            <Route path="/admissions-portal/continue" element={<LangProvider><PortalContinue /></LangProvider>} />
            <Route path="/admissions-portal/section" element={<LangProvider><PortalSection /></LangProvider>} />
            <Route path="/admissions-portal/section/:step" element={<LangProvider><PortalSection /></LangProvider>} />
            <Route path="/admissions-portal/review" element={<LangProvider><PortalReview /></LangProvider>} />

            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:inst" element={<GalleryPage />} />
            <Route path="/results" element={<ResultsPage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/notices" element={<NoticesPage />} />
            <Route path="/institutions/:slug" element={<InstitutionPage />} />
            <Route path="/departments/:slug" element={<DepartmentPage />} />
          </Route>

          {/* Admin login — public route, redirects to dashboard once signed in */}
          <Route path="/admin/login" element={<LoginPage />} />

          {/* Protected admin panel */}
          <Route
            path="/admin"
            element={
              <RequireAuth>
                <AdminLayout />
              </RequireAuth>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="slides" element={<AdminSlidesPage />} />
            <Route path="marquee" element={<AdminMarqueePage />} />
            <Route path="sections" element={<AdminSectionsPage />} />
            <Route path="institutions" element={<AdminInstitutionsPage />} />
            <Route path="departments" element={<AdminDepartmentsPage />} />
            <Route path="notices" element={<AdminNoticesPage />} />
            <Route path="results" element={<AdminResultsPage />} />
            <Route path="gallery" element={<AdminGalleryPage />} />
            <Route path="management" element={<AdminManagementPage />} />
            <Route path="teachers" element={<AdminTeachersPage />} />
            <Route path="academics" element={<AdminAcademicsPage />} />
            <Route path="about" element={<AdminAboutContentPage />} />
            <Route path="admissions" element={<AdminAdmissionsPage />} />
            <Route path="admissions-info" element={<AdminAdmissionsContentPage />} />
            <Route path="admission-rounds" element={<AdminAdmissionRoundsPage />} />
            <Route path="admission-resources" element={<AdminAdmissionResourcesPage />} />
            <Route path="activity" element={<AdminActivityContentPage />} />
            <Route path="messages" element={<AdminMessagesPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
